import { TrackingsComponent } from './containers/trakings/trackings/trackings.component'
import { Route, RouterModule } from '@angular/router'
import { LoginComponent } from './pages/login/login.component'
import { AuthGuard } from './middlewares/auth.guard'
import { ColorPaletteComponent } from './pages/color-palette/color-palette.component'
import { IncidentFormComponent } from './containers/incident-observatorio/incident-form/incident-form.component'
import { HomeComponent } from './pages/home/home.component'
import { IncidentListComponent } from './containers/incident-observatorio/incident-list/incident-list.component'
import { ListOutsiderComponent } from './containers/outsider-list/outsider-list.component'
import { EducationListComponent } from './containers/education-list/education-list.component'
import { LocationListComponent } from './containers/location-list/location-list.component'
import { ProfessionListComponent } from './containers/profession-list/profession-list.component'
import { SocialsecurityListComponent } from './containers/socialsecurity-list/socialsecurity-list.component'
import { SocioeconomicstatusListComponent } from './containers/socioeconomicstatus-list/socioeconomicstatus-list.component'
import { TrackingListComponent } from './containers/trakings/tracking-list/tracking-list.component'
import { ProfileFormComponent } from './containers/profile-form/profile-form.component'
import { ProfileListComponent } from './containers/profile-list/profile-list.component'
import { AddressListComponent } from './containers/address-list/address-list.component'
import { NotAllowedComponent } from './pages/not-allowed/not-allowed.component'
import { TablesComponent } from './containers/tables/tables.component'
import { HeatMapComponent } from './containers/heat-map/heat-map.component'
import { ListIncidentMadejaComponent } from './containers/incident-madeja/list-incident-madeja/list-incident-madeja.component'
import { IncidentMadejaComponent } from './containers/incident-madeja/incident-madeja/incident-madeja.component'
import { AccompanimentListComponent } from './containers/accompaniment/accompaniment-list/accompaniment-list.component'
import { GroupListComponent } from './containers/group/group-list/group-list.component'
import { GroupGuard } from './middlewares/group.guard'
import { NgModule } from '@angular/core'
import { AccompanimentComponent } from './containers/accompaniment/accompaniments/accompaniment.component'
import { IncidentDetailComponent } from './containers/incident-observatorio/incident-detail/incident-detail.component'
import { ReportTableComponent } from './containers/incident-madeja/report-table/report-table.component'

export type DataComponent = {
    //only staff and super users can access with this settings
    protected: boolean
    parent: string | null
    isModule: boolean
    public: boolean
    icon?: string
    menuText?: string
}

export type CustomRoute = Route & { data: DataComponent }

export const routes: CustomRoute[] = [
    {
        path: 'login',
        component: LoginComponent,
        data: {
            protected: false,
            parent: null,
            isModule: false,
            public: true,
        },
    },

    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: true,
            icon: 'home',
            menuText: 'Inicio',
        },
    },
    {
        path: 'incident/:id',
        component: IncidentFormComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: 'incident',
            isModule: false,
            public: false,
        },
    },
    {
        path: 'incident',
        component: IncidentFormComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: 'incident',
            isModule: false,
            public: false,
        },
    },
    {
        path: 'detail/:id',
        component: IncidentDetailComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: 'incident',
            isModule: false,
            public: false,
        },
    },
    {
        path: 'colors',
        component: ColorPaletteComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'palette',
            menuText: 'Paleta de colores',
        },
    },
    {
        path: 'list-incident',
        component: IncidentListComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: 'incident',
            isModule: true,
            public: false,
            icon: 'edit_document',
            menuText: 'Sucesos',
        },
    },
    {
        path: 'outsider',
        component: ListOutsiderComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'person',
            menuText: 'Personas',
        },
    },
    {
        path: 'education',
        component: EducationListComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'school',
            menuText: 'Educación',
        },
    },

    {
        path: 'location',
        component: LocationListComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'place',
            menuText: 'Ubicación',
        },
    },
    {
        path: 'profession',
        component: ProfessionListComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'work',
            menuText: 'Profesiones',
        },
    },
    {
        path: 'social-security',
        component: SocialsecurityListComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'medical_services',
            menuText: 'Seguridad Social',
        },
    },
    {
        path: 'socio-economic',
        component: SocioeconomicstatusListComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'monetization_on',
            menuText: 'Estado económico',
        },
    },
    {
        path: 'traking-incident/:id',
        component: TrackingListComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: 'incident',
            isModule: false,
            public: false,
        },
    },
    {
        path: 'list-trackings',
        component: TrackingsComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'track_changes',
            menuText: 'Seguimientos',
        },
    },
    {
        path: 'list-accompaniments',
        component: AccompanimentComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'track_changes',
            menuText: 'Acompañamientos',
        },
    },
    {
        path: 'profile',
        component: ProfileFormComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: false,
            public: false,
        },
    },
    {
        path: 'profile-list',
        component: ProfileListComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'person',
            menuText: 'Perfil',
        },
    },
    {
        path: 'address',
        component: AddressListComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'location_on',
            menuText: 'Direcciones',
        },
    },

    {
        path: 'tables',
        component: TablesComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: false,
            public: false,
        },
    },

    {
        path: 'groups',
        component: GroupListComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: true,
            public: false,
            icon: 'groups',
            menuText: 'Grupos',
        },
    },

    {
        path: 'heat-map',
        component: HeatMapComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: false,
            public: false,
        },
    },

    {
        path: 'report-table',
        component: ReportTableComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: false,
            public: false,
        },
    },

    {
        path: 'incident-madeja',
        component: IncidentMadejaComponent,
        canActivate: [AuthGuard],
        data: {
            protected: false,
            parent: null,
            isModule: false,
            public: false,
        },
    },

    {
        path: 'incident-madeja/:id',
        component: IncidentMadejaComponent,
        canActivate: [AuthGuard],
        data: {
            protected: false,
            parent: null,
            isModule: false,
            public: false,
        },
    },

    {
        path: 'list-incident-madeja',
        component: ListIncidentMadejaComponent,
        canActivate: [AuthGuard],
        data: {
            protected: false,
            parent: 'incident',
            isModule: true,
            public: false,
            icon: 'edit_document',
            menuText: 'Incidentes Madeja',
        },
    },

    {
        path: 'list-accompaniment/:id',
        component: AccompanimentListComponent,
        canActivate: [AuthGuard],
        data: {
            protected: false,
            parent: null,
            isModule: false,
            public: false,
        },
    },

    {
        path: 'not-allowed',
        component: NotAllowedComponent,
        canActivate: [AuthGuard, GroupGuard],
        data: {
            protected: false,
            parent: null,
            isModule: false,
            public: false,
        },
    },

    {
        path: '**',
        redirectTo: 'login',
        data: {
            protected: false,
            parent: null,
            isModule: false,
            public: true,
        },
    },
]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
export const routeList = routes
